import BaseConverter from './BaseConverter'
import { ConverterTypes } from './constants'


class TextConverter extends BaseConverter {
  constructor(markupIdentifier) {
    super(markupIdentifier, ConverterTypes.TEXT)
  }
}

export default TextConverter